import React from 'react';
import './styles/Loader.css';

const loader = (props) => {
  return (
    <div className="lds-dual-ring">
      <div
        style={{
          border: `6px solid ${props.color}`,
          borderColor: `${props.color} transparent ${props.color} transparent`
        }}
      ></div>
    </div>
  );
};

export default loader;
